import React, { memo, useMemo } from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { CitiesList } from "./index-styled";
import { useHighlightedCitiesQuery } from "@/hooks/queries/useHighlightedCitiesQuery";
import QueryRequest from "../QueryRequest";
import isempty from "lodash/isEmpty";
import { useParsedQuery } from "@/hooks/useParsedQuery";
import { useSearchUrlGenerator } from "@/hooks/useSearchUrlGenerator";
import type {TFunction} from "i18next";

type tProps = {
  hl?: string;
  t: TFunction
};
const FooterCities = ({ hl: _hl, t }: tProps) => {
  const { pathname } = useLocation();
  const searchMatchedPath = useMemo(() => {
    return matchPath<{ loc?: string; spec?: string }>(pathname, {
      path: "/search/:loc/:spec?",
    });
  }, [pathname]);
  const isOnTheSearchPage = pathname.startsWith("/search");
  const parsedQuery: tStringDict = useParsedQuery();
  const searchPageQuery = useMemo(() => {
    if (isOnTheSearchPage) {
      // https://trello.com/c/CJ0S8kRN
      return { ...parsedQuery, id: undefined };
    } else {
      return {};
    }
  }, [parsedQuery, isOnTheSearchPage]);
  const generateSearchUrl = useSearchUrlGenerator();
  const generateUrl = (slug: string) => {
    return generateSearchUrl({
      params: {
        spec: isOnTheSearchPage
          ? searchMatchedPath?.params?.spec || parsedQuery.spec
          : undefined,
        loc: slug,
      },
      query: searchPageQuery,
    });
  };
  const citiesQuery = useHighlightedCitiesQuery();
  const cities = useMemo(() => {
    const data = citiesQuery.data;
    if(isempty(data)) return [];
    return data!.slice(0, 12);
  }, [citiesQuery.data]);
  return (
    <QueryRequest query={citiesQuery}>
      {!isempty(cities) && (
        <CitiesList>
          {cities!.map(({ _id, slug, name }) => (
            <li key={_id}>
              <Link to={generateUrl(slug)}>{name}</Link>
            </li>
          ))}
          <li>
            <Link to="/city">{t("common:cities_page_link")}</Link>
          </li>
        </CitiesList>
      )}
    </QueryRequest>
  );
};
export default memo(FooterCities);
